<template>
  <form @submit.prevent="onSubmit">
    <div class="form-group">
      <label for="answer">{{ $t('answer') }}</label>
      <input id="answer" name="answer" type="text" class="form-control" v-model="model.answer" required>
    </div>
    <div class="form-group">
      <label for="sourceData">{{ $t('sourceData') }}</label>
      <input id="sourceData" name="sourceData" type="text" class="form-control" v-model="model.sourceData">
    </div>
    <div class="form-group">
      <label>{{ $t('itemType') }}</label>
      <div class="radio-box">
        <div class="btn-group btn-group-toggle">
          <dx-spinner :active="loadingCardTypes" />
          <label :class="{ 'btn': true, 'btn-sm': true, 'btn-primary': true, 'active': model.cardTypeId === item.id }" v-for="item in cardTypes" :key="item.id">
            <input type="radio" v-model="model.cardTypeId" :value="item.id">
            {{ $t(item.name) }}
          </label>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>{{ $t('level') }}</label>
      <div class="radio-box">
        <div class="btn-group btn-group-toggle">
          <dx-spinner :active="loadingCardLevels" />
          <label :class="{ 'btn': true, 'btn-sm': true, 'btn-primary': true, 'active': model.cardLevelId === item.id }" v-for="item in cardLevels" :key="item.id">
            <input type="radio" v-model="model.cardLevelId" :value="item.id">
            {{ $t(item.name) }}
          </label>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="tip">{{ $t('tips') }}</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <dx-button primary small @click.native="addTip">
            <icon name="plus" />
          </dx-button>
        </div>
        <input name="tip" type="text" class="form-control" v-model="tip" ref="tip" @keydown.enter.prevent="addTip">
      </div>
    </div>
    <div class="form-group">
      <div class="card" v-if="model.cardTipsAttributes.length > 0">
        <ol class="list-group list-group-flush">
          <li
            v-for="(item, index) in model.cardTipsAttributes"
            :key="index"
            class="list-group-item"
            >
            <dx-button
              :danger="!item._destroy"
              :info="item._destroy"
              small
              @click.native="removeTip(index)"
              >
              <icon name="times" v-if="!item._destroy" />
              <icon name="refresh" v-if="item._destroy" />
            </dx-button>
            <span class="badge badge-secondary">
              {{ index + 1 }}
            </span>
            <del v-if="item._destroy">{{ item.tip }}</del>
            <span v-if="!item._destroy">{{ item.tip }}</span>
          </li>
        </ol>
      </div>
    </div>
    <div class="float-right">
      <dx-button default v-if="edit" @click.native="$emit('cancel')">
        {{ $t('cancel') }}
      </dx-button>
    </div>
    <dx-button success large :loading="disabled" type="submit">
      {{ buttonLabel }}
    </dx-button>
  </form>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/refresh'
import DxButton from './DxButton.vue'
import DxSpinner from './DxSpinner.vue'

export default {
  name: 'dx-card-form',
  props: {
    card: Object,
    disabled: Boolean,
    edit: Boolean
  },
  components: {
    DxButton,
    DxSpinner
  },
  data () {
    return {
      model: {
        answer: '',
        cardTypeId: '',
        cardLevelId: '',
        sourceData: '',
        cardTipsAttributes: []
      },
      tip: '',
      loadingCardTypes: true,
      loadingCardLevels: true
    }
  },
  methods: {
    ...mapActions([
      'loadCardTypes',
      'loadCardLevels'
    ]),
    onSubmit () {
      this.$emit('submit', this.model)
    },
    addTip () {
      if (this.tip) {
        if (_.findIndex(this.model.cardTipsAttributes, { tip: this.tip }) === -1) {
          this.model.cardTipsAttributes.push({ tip: this.tip })
          this.tip = ''
        }
      }
      this.$refs.tip.focus()
    },
    removeTip (index) {
      if (this.model.cardTipsAttributes[index].id) {
        if (!this.model.cardTipsAttributes[index]._destroy) {
          this.model.cardTipsAttributes[index]._destroy = true
        } else {
          delete this.model.cardTipsAttributes[index]._destroy
        }
      } else {
        this.model.cardTipsAttributes.splice(index, 1)
      }
      this.$forceUpdate()
    },
    cleanData () {
      this.model.answer = ''
      this.model.cardTypeId = ''
      this.model.cardLevelId = ''
      this.model.sourceData = ''
      this.model.cardTipsAttributes = []
    }
  },
  computed: {
    ...mapGetters({
      cardTypes: 'getCardTypes',
      cardLevels: 'getCardLevels'
    }),
    buttonLabel () {
      if (this.edit) {
        return this.$t('update')
      }
      return this.$t('save')
    }
  },
  created () {
    this.loadCardTypes().then(() => {
      this.loadingCardTypes = false
    }).catch(() => {
      this.loadingCardTypes = false
    })

    this.loadCardLevels().then(() => {
      this.loadingCardLevels = false
    }).catch(() => {
      this.loadingCardTypes = false
    })

    if (this.card) {
      this.model.answer = this.card.answer
      this.model.sourceData = this.card.source_data
      this.model.cardLevelId = this.card.card_level.id
      this.model.cardTypeId = this.card.card_type.id
      this.model.cardTipsAttributes = this.card.card_tips
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxCardForm.vue